(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faqs-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const items = document.querySelectorAll('.faq-item');

  items.forEach(item => {
    const question = item.querySelector('.faq-question');

    question.addEventListener('click', () => {

      // Close all others
      items.forEach(i => {
        const ans = i.querySelector('.faq-answer');
        const ic = i.querySelector('.faq-icon');

        if (i !== item) {
          ans.style.display = 'none';
          ic.textContent = '+';
          i.classList.remove('active');
        }
      });

      // Toggle current
      const answer = item.querySelector('.faq-answer');
      const icon = item.querySelector('.faq-icon');

      if (answer.style.display === 'block') {
        answer.style.display = 'none';
        icon.textContent = '+';
        item.classList.remove('active');
      } else {
        answer.style.display = 'block';
        icon.textContent = '−';
        item.classList.add('active');
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["temp-recieps-library"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ssv-recipe-search')) {
 class SSVRecipeSearch extends HTMLElement {
  connectedCallback() {
   if (this.controller) this.controller.abort();
   this.controller = new AbortController();
   const input = this.querySelector('[data-recipe-search]');
   const cards = Array.from(this.querySelectorAll('[data-recipe-card]'));
   const empty = this.querySelector('[data-recipe-empty]');
   const status = this.querySelector('[data-recipe-status]');
   const normalise = value => value.normalize('NFKC').toLocaleLowerCase().trim();
   const filter = (announce = false) => {
    const query = normalise(input ? input.value : '');
    let count = 0;
    cards.forEach(card => {
     const match = normalise(card.dataset.search || '').includes(query);
     card.hidden = !match;
     if (match) count++;
    });
    if (empty) empty.hidden = count !== 0;
    if (announce && status) status.textContent = `${count} ${status.dataset.countLabel}`;
   };
   if (input) input.addEventListener('input', () => filter(true), { signal: this.controller.signal });
   filter();
  }
  disconnectedCallback() { if (this.controller) this.controller.abort(); }
 }
 customElements.define('ssv-recipe-search', SSVRecipeSearch);
}

  } catch(e) { console.error(e); }
})();
})();
